/**
 * Normalized fetch error. `message` holds the best available server text and
 * is used for diagnostics; `detail` holds the server-provided message (RFC
 * 7807 `detail`, or a JSON `message` field) when one exists, so UI code can
 * decide whether it is safe and relevant to show to the user.
 */
class FetchError extends Error {
  status?: number
  detail?: string
  constructor(message: string, status?: number, detail?: string) {
    super(message)
    this.name = 'FetchError'
    this.status = status
    this.detail = detail
  }
}

export default FetchError
